import React, { Component } from 'react';
import Section from './Section.js'
import {reduxForm, Field} from 'redux-form';
import { withRouter } from 'react-router';
import {FormattedHTMLMessage} from 'react-intl';
import validate from './Validations/submitValidationsCompanyRepresentativeForm.js';
import CustomAlert from './CustomAlert.js';
import RenderField from './RenderField.js';
import CustomSpinner from './CustomSpinner.js';
import withAuthControl from '../auth/Auth.js';

class CompanyRepresentativeForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: false
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        const name = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="name" autoComplete="off" component={RenderField} type='text' label="Nombre o Razón Social" />
                </div>
            </div>
        );

        const cuil = (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field className="form-control" name="cuil" autoComplete="off" component={RenderField} type='cuil' label="Cuit /Cuil" />
                </div>
            </div>
        );


        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)} />
                        <FormattedHTMLMessage id="app.step_company_representative" description="Company representative" />
                    </div>
                    <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                        {this.state.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá.... Por favor espere...' />}
                        <div>
                            <form onSubmit={handleSubmit(this.props.validateCompanyRepresentative)} className='pvc-form'>
                                {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' />}
                                {error && <CustomAlert bsStyle="danger" message={error} />}
                                <div className="row">
                                    {name}
                                    {cuil}
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Continuar</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

CompanyRepresentativeForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

CompanyRepresentativeForm = reduxForm({
    form: 'CompanyRepresentativeForm', // a unique name for this form
    validate,
})(CompanyRepresentativeForm);

CompanyRepresentativeForm = withRouter(CompanyRepresentativeForm);

CompanyRepresentativeForm = withAuthControl(CompanyRepresentativeForm);

export default CompanyRepresentativeForm;



/** WEBPACK FOOTER **
 ** ./src/components/CompanyRepresentativeForm.js
 **/